var videoLoadStatuses = {};

function renderVideoElement(
  sectionId,
  videoContentBody,
  videoButtonMutedOn,
  videoButtonMutedOff,
  desktopVideo = true,
  videoButtonLink = null,
  videoSourceUrl = '',
  videoCoverImg = '',
  isHomepage = false
) {
  var loadFirstVideo = false;
  if (videoLoadStatuses.sectionId === undefined) {
    if (Object.keys(videoLoadStatuses).length === 0 && isHomepage) {
      loadFirstVideo = true;
    }

    videoLoadStatuses[sectionId] = false;
  }

  if (videoButtonLink !== null) {
    videoContentBody.innerHTML =
      '<a href="' + videoButtonLink + '">' +
        '<video id="video-' + sectionId + '" width="100%" playsinline muted loop preload="none" poster="' + videoCoverImg + '">' +
          '<source src="' + videoSourceUrl + '" type="video/mp4">' +
        '</video>' +
      '</a>';
  } else {
    videoContentBody.innerHTML =
      '<video id="video-' + sectionId + '" width="100%" playsinline muted loop preload="none" poster="' + videoCoverImg + '">' +
        '<source src="' + videoSourceUrl + '" type="video/mp4">' +
      '</video>';
  }

  // Get video element
  var video = document.getElementById('video-' + sectionId);
  
  if (video !== null) {
    // Check if this is first video
    // If it's first video, then we will load it immediately
    if (loadFirstVideo) {
        loadVideo(sectionId, video);
    } else {
      // If it's mobile view, then we need to play video after there's scroll or after 5 seconds it will automatically load the video
      // If not, it will play the video on mouseover
      if (!desktopVideo) {
        document.addEventListener('scroll', function () {
          loadVideo(sectionId, video);
        });
  
        setTimeout(function () {
          loadVideo(sectionId, video);
        }, 5000);
      } else {
          video.addEventListener('mouseover', function () {
            loadVideo(sectionId, video);
          });
      }
    }
  }
    
  // Add event to mute/unmute video
  videoButtonMutedOn.addEventListener('click', function () {
    if (video !== null) {
      if (video.muted) {
        video.muted = false;
      }
    }

    this.style.display = 'none';
    videoButtonMutedOff.style.display = 'block';
  });

  videoButtonMutedOff.addEventListener('click', function () {
    if (video !== null) {
      if (!video.muted) {
        video.muted = true;
      }
    }
    
    this.style.display = 'none';
    videoButtonMutedOn.style.display = 'block';
  });
}

function loadVideo(sectionId, video) {
  if (videoLoadStatuses[sectionId] === undefined) {
    return;
  }
  if (!videoLoadStatuses[sectionId]) {
    video.load();
    video.play();
    videoLoadStatuses[sectionId] = true;
  }
}